import { JepWebTileLayer } from '@jeppesen-foreflight/jmkw-types';

export const AIR_TEMPERATURE_LAYER = new JepWebTileLayer({
  visible: false,
  zOrder: 1,
  urlTemplate:
    'http://tile.openweathermap.org/map/temp_new/{z}/{x}/{y}.png?APPID=05c77c9714ee57ca555a008f84251057'
});
